import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import feathersVuex from 'feathers-vuex'
import feathersClient from '../api/feathers-client'
import account from './modules/account'
import appSettings from './modules/appSettings'
import current from '@/store/modules/current'

Vue.use(Vuex)

const {
  service,
  auth
} = feathersVuex(feathersClient, {
  idField: '_id'
})

export default new Vuex.Store({
  strict: true,
  defaultOptions: {
    idField: '_id'
  },
  plugins: [
    service('users'),
    service('account', account),
    service('profile'),
    service('stream'),
    service('appsettings', appSettings),
    service('webcast'),
    service('qna', {
      debug: true
    }),
    service('reg-form'),
    service('registrations'),
    service('attendees'),
    service('page-settings'),
    service('landing-content'),
    service('webcast-session'),
    service('session-connections'),
    service('realtime-stats', {
      debug: true
    }),
    service('widgets'),
    service('agg-connections'),
    service('user-permissions'),
    service('slides'),
    service('teamchat'),
    service('audio-room'),
    service('audio-participants'),
    service('speakers'),
    service('download'),
    service('emails'),

    //service('chat', chat),

    auth({
      userService: 'users',
    })

  ],
  modules: {
    current,
  },
})